import * as React from 'react';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import Badge from '@mui/material/Badge';

export default function AvatarsGrid({ avatars,position }) {
  return (
    <Box sx={{ flexGrow: 1, padding: 2 }}>
      <Stack direction="row" spacing={3} justifyContent="center" alignItems="center">
      {avatars?.map((avatar, index) => {
          console.log(
            `Avatar at index ${index}:`,
            `Avatar position ${position}:`,
           `MoveStatus: ${avatar?.moveStatus || "No moveStatus"}`
          ); // Log details of each avatar
          return (
            <Badge
              key={index}
              badgeContent={avatar?.moveStatus}
              color="error" // Set badge color to red
              sx={{
                "& .MuiBadge-badge": {
                  top: -5, // Adjust badge position
                  right: -5,
                },
              }}
            >
              <Avatar
                alt={avatar?.name} // Use `name` from the avatar data
                src={avatar?.url} // Use `url` from the avatar data
                style={{
                  border: "2px solid #fff",
                  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.2)",
                  width: "50px", // Adjust avatar size
                  height: "50px",
                }}
                variant="square"
              />
            </Badge>
          );
        })}
      </Stack>
    </Box>
  );
}
